<template>
<div>
    <h3>{{$t('message.webinars')}}</h3>
        <div class="row" >
            <div class="col-12 text-center"> 
                <h3>{{$t('message.timetable')}}</h3>
                {{$t('message.timetable_text')}}
                <div>

                    <ul class="webin_subs">
                        <li><a class="tn-atom" href="https://iiii.chat/tP4v_8c02"  target="_blank"> <img src="https://static.tildacdn.com/tild3833-3834-4536-b361-353736663765/download.svg"> </a></li>
                        <li><a class="tn-atom" href="https://iiii.chat/tP4v_bc79"  target="_blank"> <img src="https://static.tildacdn.com/tild3937-3763-4037-b735-356562303166/viber.svg"> </a></li>
                        <li><a class="tn-atom" href="https://iiii.chat/tP4v_9914"  target="_blank"> <img src="https://static.tildacdn.com/tild6334-3363-4265-b932-643130343265/telegram.svg"> </a></li>
                        <li><a class="tn-atom" href="https://iiii.chat/tP4v_a49f"  target="_blank"> <img src="https://static.tildacdn.com/tild3330-6437-4164-b737-613934373965/facebook.svg"> </a></li>

                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center"> 
                <h3>{{$t('message.past')}}</h3>
                <academy :type=1></academy>
            </div>

        </div>  
    </div>
</template>

<script>
import Academy from '@/components/academy'; 
export default {
  name: 'acad_webinars',
  data () {
        return {
            webinars_list:[]
        }
  },
  methods:{
      
  },
  components:{
    Academy
  },
  mounted() {
      
  },
}

</script>



	